import { useEffect, useState, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { supabase } from '@/infrastructure/supabase/client'
import type { UserRole, Plan, CustomPlanLimits } from '@brix/types'

export function TenantGuard({ children }: { children: ReactNode }) {
  const { user, tenant, setTenant } = useAuthStore()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) { setLoading(false); return }
    if (tenant) { setLoading(false); return }

    // Fetch tenant + the current user's role in one query
    supabase
      .from('users')
      .select('role, tenants(id, name, slug, plan, custom_limits, created_at, updated_at)')
      .eq('id', user.id)
      .single()
      .then(({ data }) => {
        if (data?.tenants) {
          const t = data.tenants
          setTenant(
            {
              id: t.id,
              name: t.name,
              slug: t.slug,
              plan: t.plan as Plan,
              customLimits: t.custom_limits as unknown as CustomPlanLimits | null,
              createdAt: t.created_at,
              updatedAt: t.updated_at,
            },
            (data.role as UserRole) ?? 'member',
          )
        }
        setLoading(false)
      })
  }, [user, tenant, setTenant])

  if (!user || loading) return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-gray-700" />
    </div>
  )
  if (!tenant) return <Navigate to="/onboarding" replace />

  return <>{children}</>
}
